import { UUID } from "@bitory-gmbh/nidavellir";
import { useSamplesLaboratoryShowQuery } from "@/services/backend/samples/api/lab-api";

export function LaboratoryName({ id }: { id: UUID }) {
  const { data } = useSamplesLaboratoryShowQuery({
    id: id ?? "",
  });

  if (!data) {
    return null;
  }

  return <span>{data.name}</span>;
}
